// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LiveChat Component Styles */

.live-chat {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 70px);
    max-width: 1200px;
    margin: 0 auto;
    background: #f8f9fa;
}

.live-chat.loading,
.live-chat.error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 20px;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #e0e0e0;
    border-top-color: #25D366;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.error-icon {
    font-size: 48px;
}

/* Header */
.chat-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    background: white;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
    gap: 15px;
}

.header-left,
.header-right {
    flex-shrink: 0;
}

.header-center {
    flex: 1 1;
    display: flex;
    justify-content: center;
}

.btn-back {
    background: none;
    border: none;
    font-size: 14px;
    cursor: pointer;
    color: #2196F3;
    padding: 8px 12px;
    border-radius: 6px;
    transition: background-color 0.2s;
}

.btn-back:hover {
    background-color: #e3f2fd;
}

.contact-info {
    text-align: center;
}

.contact-info h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.contact-meta {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-top: 4px;
}

.platform-badge,
.agent-badge {
    font-size: 11px;
    color: #666;
    background: #e9ecef;
    padding: 2px 8px;
    border-radius: 10px;
    text-transform: capitalize;
}

.platform-badge.instagram-dm {
    background: linear-gradient(135deg, #833AB4, #C13584, #E1306C);
    color: white;
}

.platform-badge.facebook-message {
    background: #0084FF;
    color: white;
}

.window-expired-badge {
    font-size: 11px;
    color: #856404;
    background: #fff3cd;
    padding: 2px 8px;
    border-radius: 10px;
}

.sentiment-badge {
    font-size: 11px;
    color: white;
    padding: 2px 8px;
    border-radius: 10px;
    text-transform: capitalize;
}

/* AI Controls */
.ai-controls {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ai-status {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 13px;
}

.ai-status.active {
    background: #e8f5e9;
    color: #2e7d32;
}

.ai-status.paused {
    background: #ffebee;
    color: #c62828;
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.ai-status.active .status-dot {
    background: #4caf50;
    animation: pulse 2s infinite;
}

.ai-status.paused .status-dot {
    background: #f44336;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }
}

.auto-resume {
    font-size: 11px;
    opacity: 0.8;
    margin-left: 4px;
}

.btn-action {
    padding: 8px 14px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s;
}

.btn-action:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-pause {
    background: #ff9800;
    color: white;
}

.btn-pause:hover:not(:disabled) {
    background: #f57c00;
}

.btn-resume {
    background: #4caf50;
    color: white;
}

.btn-resume:hover:not(:disabled) {
    background: #388e3c;
}

.btn-takeover {
    background: #f44336;
    color: white;
}

.btn-takeover:hover:not(:disabled) {
    background: #d32f2f;
}

/* Stats Bar */
.stats-bar {
    display: flex;
    gap: 20px;
    padding: 10px 20px;
    background: white;
    border-bottom: 1px solid #e0e0e0;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 8px;
}

.stat-label {
    font-size: 12px;
    color: #666;
}

.stat-value {
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

/* Messages */
.messages-container {
    flex: 1 1;
    overflow-y: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: linear-gradient(180deg, #f8f9fa 0%, #fff 100%);
}

.no-messages {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
    font-style: italic;
}

.live-message {
    display: flex;
    gap: 10px;
    max-width: 75%;
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.live-message.inbound {
    align-self: flex-start;
}

.live-message.outbound {
    align-self: flex-end;
    flex-direction: row-reverse;
}

.message-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #e9ecef;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
}

.message-bubble {
    padding: 10px 14px;
    border-radius: 16px;
    position: relative;
}

.live-message.inbound .message-bubble {
    background: white;
    border: 1px solid #e0e0e0;
    border-bottom-left-radius: 4px;
}

.live-message.outbound .message-bubble {
    border-bottom-right-radius: 4px;
}

.live-message.outbound.ai .message-bubble {
    background: #e3f2fd;
    border: 1px solid #bbdefb;
}

.live-message.outbound.human_agent .message-bubble {
    background: #25D366;
    color: white;
}

.message-sender {
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 4px;
    opacity: 0.7;
}

.live-message.outbound.human_agent .message-sender {
    color: rgba(255, 255, 255, 0.9);
}

.message-content {
    font-size: 14px;
    line-height: 1.45;
    word-wrap: break-word;
    white-space: pre-wrap;
}

.message-footer {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
    flex-wrap: wrap;
}

.message-time {
    font-size: 10px;
    opacity: 0.6;
}

.message-sentiment {
    font-size: 9px;
    padding: 2px 6px;
    border-radius: 8px;
    color: white;
    text-transform: capitalize;
}

.message-response-time {
    font-size: 10px;
    opacity: 0.6;
}

/* Warning Banner */
.warning-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 20px;
    background: #fff3e0;
    color: #e65100;
    font-size: 13px;
    flex-shrink: 0;
}

.warning-icon {
    font-size: 16px;
}

/* Input Form */
.message-input-form {
    display: flex;
    padding: 15px 20px;
    background: white;
    border-top: 1px solid #e0e0e0;
    gap: 12px;
    flex-shrink: 0;
}

.message-input {
    flex: 1 1;
    padding: 14px 18px;
    border: 1px solid #e0e0e0;
    border-radius: 25px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.message-input:focus {
    border-color: #25D366;
    box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
}

.message-input:disabled {
    background: #f5f5f5;
    color: #999;
}

.btn-send {
    width: 50px;
    height: 50px;
    border: none;
    border-radius: 50%;
    background: #25D366;
    color: white;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s, transform 0.1s;
    flex-shrink: 0;
}

.btn-send:hover:not(:disabled) {
    background: #128C7E;
    transform: scale(1.05);
}

.btn-send:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
}

.sending-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

/* Responsive */
@media (max-width: 768px) {
    .live-chat {
        height: calc(100vh - 60px);
    }

    .chat-header {
        flex-wrap: wrap;
        gap: 10px;
        padding: 10px 15px;
    }

    .header-center {
        order: -1;
        width: 100%;
        justify-content: flex-start;
    }

    .contact-info {
        text-align: left;
    }

    .ai-controls {
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .ai-status {
        font-size: 12px;
        padding: 4px 10px;
    }

    .btn-action {
        font-size: 12px;
        padding: 6px 10px;
    }

    .stats-bar {
        padding: 8px 15px;
        gap: 15px;
        overflow-x: auto;
    }

    .messages-container {
        padding: 15px;
    }

    .live-message {
        max-width: 85%;
    }

    .message-input-form {
        padding: 12px 15px;
    }

    .message-input {
        padding: 12px 16px;
    }

    .btn-send {
        width: 44px;
        height: 44px;
        font-size: 18px;
    }
}

@media (max-width: 480px) {
    .chat-header {
        padding: 8px 12px;
    }

    .contact-info h2 {
        font-size: 14px;
    }

    .btn-action {
        font-size: 11px;
        padding: 5px 8px;
    }

    .live-message {
        max-width: 90%;
    }

    .message-bubble {
        padding: 8px 12px;
    }

    .message-content {
        font-size: 13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/LiveChat.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,cAAc;IACd,SAAS;AACb;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,8DAA8D;IAC9D,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI;;QAEI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,aAAa;AACb;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iDAAiD;IACjD,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA,eAAe;AACf;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* LiveChat Component Styles */\n\n.live-chat {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 70px);\n    max-width: 1200px;\n    margin: 0 auto;\n    background: #f8f9fa;\n}\n\n.live-chat.loading,\n.live-chat.error {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 20px;\n}\n\n.loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #e0e0e0;\n    border-top-color: #25D366;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.error-icon {\n    font-size: 48px;\n}\n\n/* Header */\n.chat-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 20px;\n    background: white;\n    border-bottom: 1px solid #e0e0e0;\n    flex-shrink: 0;\n    gap: 15px;\n}\n\n.header-left,\n.header-right {\n    flex-shrink: 0;\n}\n\n.header-center {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n}\n\n.btn-back {\n    background: none;\n    border: none;\n    font-size: 14px;\n    cursor: pointer;\n    color: #2196F3;\n    padding: 8px 12px;\n    border-radius: 6px;\n    transition: background-color 0.2s;\n}\n\n.btn-back:hover {\n    background-color: #e3f2fd;\n}\n\n.contact-info {\n    text-align: center;\n}\n\n.contact-info h2 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n.contact-meta {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    margin-top: 4px;\n}\n\n.platform-badge,\n.agent-badge {\n    font-size: 11px;\n    color: #666;\n    background: #e9ecef;\n    padding: 2px 8px;\n    border-radius: 10px;\n    text-transform: capitalize;\n}\n\n.platform-badge.instagram-dm {\n    background: linear-gradient(135deg, #833AB4, #C13584, #E1306C);\n    color: white;\n}\n\n.platform-badge.facebook-message {\n    background: #0084FF;\n    color: white;\n}\n\n.window-expired-badge {\n    font-size: 11px;\n    color: #856404;\n    background: #fff3cd;\n    padding: 2px 8px;\n    border-radius: 10px;\n}\n\n.sentiment-badge {\n    font-size: 11px;\n    color: white;\n    padding: 2px 8px;\n    border-radius: 10px;\n    text-transform: capitalize;\n}\n\n/* AI Controls */\n.ai-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.ai-status {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 13px;\n}\n\n.ai-status.active {\n    background: #e8f5e9;\n    color: #2e7d32;\n}\n\n.ai-status.paused {\n    background: #ffebee;\n    color: #c62828;\n}\n\n.status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n}\n\n.ai-status.active .status-dot {\n    background: #4caf50;\n    animation: pulse 2s infinite;\n}\n\n.ai-status.paused .status-dot {\n    background: #f44336;\n}\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.5;\n    }\n}\n\n.auto-resume {\n    font-size: 11px;\n    opacity: 0.8;\n    margin-left: 4px;\n}\n\n.btn-action {\n    padding: 8px 14px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.btn-action:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.btn-pause {\n    background: #ff9800;\n    color: white;\n}\n\n.btn-pause:hover:not(:disabled) {\n    background: #f57c00;\n}\n\n.btn-resume {\n    background: #4caf50;\n    color: white;\n}\n\n.btn-resume:hover:not(:disabled) {\n    background: #388e3c;\n}\n\n.btn-takeover {\n    background: #f44336;\n    color: white;\n}\n\n.btn-takeover:hover:not(:disabled) {\n    background: #d32f2f;\n}\n\n/* Stats Bar */\n.stats-bar {\n    display: flex;\n    gap: 20px;\n    padding: 10px 20px;\n    background: white;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.stat-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.stat-label {\n    font-size: 12px;\n    color: #666;\n}\n\n.stat-value {\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n}\n\n/* Messages */\n.messages-container {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    background: linear-gradient(180deg, #f8f9fa 0%, #fff 100%);\n}\n\n.no-messages {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    color: #999;\n    font-style: italic;\n}\n\n.live-message {\n    display: flex;\n    gap: 10px;\n    max-width: 75%;\n    animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.live-message.inbound {\n    align-self: flex-start;\n}\n\n.live-message.outbound {\n    align-self: flex-end;\n    flex-direction: row-reverse;\n}\n\n.message-avatar {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: #e9ecef;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    flex-shrink: 0;\n}\n\n.message-bubble {\n    padding: 10px 14px;\n    border-radius: 16px;\n    position: relative;\n}\n\n.live-message.inbound .message-bubble {\n    background: white;\n    border: 1px solid #e0e0e0;\n    border-bottom-left-radius: 4px;\n}\n\n.live-message.outbound .message-bubble {\n    border-bottom-right-radius: 4px;\n}\n\n.live-message.outbound.ai .message-bubble {\n    background: #e3f2fd;\n    border: 1px solid #bbdefb;\n}\n\n.live-message.outbound.human_agent .message-bubble {\n    background: #25D366;\n    color: white;\n}\n\n.message-sender {\n    font-size: 11px;\n    font-weight: 600;\n    margin-bottom: 4px;\n    opacity: 0.7;\n}\n\n.live-message.outbound.human_agent .message-sender {\n    color: rgba(255, 255, 255, 0.9);\n}\n\n.message-content {\n    font-size: 14px;\n    line-height: 1.45;\n    word-wrap: break-word;\n    white-space: pre-wrap;\n}\n\n.message-footer {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 6px;\n    flex-wrap: wrap;\n}\n\n.message-time {\n    font-size: 10px;\n    opacity: 0.6;\n}\n\n.message-sentiment {\n    font-size: 9px;\n    padding: 2px 6px;\n    border-radius: 8px;\n    color: white;\n    text-transform: capitalize;\n}\n\n.message-response-time {\n    font-size: 10px;\n    opacity: 0.6;\n}\n\n/* Warning Banner */\n.warning-banner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 20px;\n    background: #fff3e0;\n    color: #e65100;\n    font-size: 13px;\n    flex-shrink: 0;\n}\n\n.warning-icon {\n    font-size: 16px;\n}\n\n/* Input Form */\n.message-input-form {\n    display: flex;\n    padding: 15px 20px;\n    background: white;\n    border-top: 1px solid #e0e0e0;\n    gap: 12px;\n    flex-shrink: 0;\n}\n\n.message-input {\n    flex: 1;\n    padding: 14px 18px;\n    border: 1px solid #e0e0e0;\n    border-radius: 25px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.message-input:focus {\n    border-color: #25D366;\n    box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);\n}\n\n.message-input:disabled {\n    background: #f5f5f5;\n    color: #999;\n}\n\n.btn-send {\n    width: 50px;\n    height: 50px;\n    border: none;\n    border-radius: 50%;\n    background: #25D366;\n    color: white;\n    font-size: 20px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s, transform 0.1s;\n    flex-shrink: 0;\n}\n\n.btn-send:hover:not(:disabled) {\n    background: #128C7E;\n    transform: scale(1.05);\n}\n\n.btn-send:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.sending-spinner {\n    width: 20px;\n    height: 20px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .live-chat {\n        height: calc(100vh - 60px);\n    }\n\n    .chat-header {\n        flex-wrap: wrap;\n        gap: 10px;\n        padding: 10px 15px;\n    }\n\n    .header-center {\n        order: -1;\n        width: 100%;\n        justify-content: flex-start;\n    }\n\n    .contact-info {\n        text-align: left;\n    }\n\n    .ai-controls {\n        flex-wrap: wrap;\n        justify-content: flex-end;\n    }\n\n    .ai-status {\n        font-size: 12px;\n        padding: 4px 10px;\n    }\n\n    .btn-action {\n        font-size: 12px;\n        padding: 6px 10px;\n    }\n\n    .stats-bar {\n        padding: 8px 15px;\n        gap: 15px;\n        overflow-x: auto;\n    }\n\n    .messages-container {\n        padding: 15px;\n    }\n\n    .live-message {\n        max-width: 85%;\n    }\n\n    .message-input-form {\n        padding: 12px 15px;\n    }\n\n    .message-input {\n        padding: 12px 16px;\n    }\n\n    .btn-send {\n        width: 44px;\n        height: 44px;\n        font-size: 18px;\n    }\n}\n\n@media (max-width: 480px) {\n    .chat-header {\n        padding: 8px 12px;\n    }\n\n    .contact-info h2 {\n        font-size: 14px;\n    }\n\n    .btn-action {\n        font-size: 11px;\n        padding: 5px 8px;\n    }\n\n    .live-message {\n        max-width: 90%;\n    }\n\n    .message-bubble {\n        padding: 8px 12px;\n    }\n\n    .message-content {\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
